import { Routes } from '@angular/router';
import { AppLayout } from '@/core/layout/components/app.layout';
import { authGuard } from '@/core/auth/auth.guard';
import { adminGuard } from '@/core/admin/guards/admin.guard';
import authRoutes from '@/core/auth/auth.routes';
import { ADMIN_AREA_LABEL } from '@/core/layout/admin-registry';

export const appRoutes: Routes = [
  {
    path: '',
    component: AppLayout,
    children: [
      { path: '', redirectTo: '/my/workspace', pathMatch: 'full' }, // My Workspace is the homepage
      {
        path: 'my',
        canActivate: [authGuard],
        loadChildren: () => import('@/features/my/my.routes'),
      },
      {
        path: 'apps',
        data: { breadcrumb: 'Apps' },
        canActivate: [authGuard],
        loadChildren: () => import('@/apps/apps.routes'),
      },
      {
        // `/devices/activate` is the URL a TV shows while pairing (API `verificationUrl`).
        // Any signed-in user may open it; the API decides who may approve.
        path: 'devices',
        data: { breadcrumb: 'Devices' },
        canActivate: [authGuard],
        loadChildren: () => import('@/features/devices/devices.routes'),
      },
    ],
  },
  {
    path: 'admin',
    component: AppLayout,
    data: { breadcrumb: ADMIN_AREA_LABEL },
    canActivate: [authGuard, adminGuard],
    loadChildren: () => import('@/core/admin/admin.routes'),
  },
  { path: 'auth', children: authRoutes },
  {
    path: 'notfound',
    loadComponent: () => import('@/pages/notfound/notfound').then((c) => c.Notfound),
  },
  {
    path: 'service-unavailable',
    loadComponent: () =>
      import('@/pages/service-unavailable/service-unavailable.component').then(
        (c) => c.ServiceUnavailableComponent
      ),
  },
  {
    matcher: (url) => {
      // Don't match auth/callback or service-unavailable routes
      if (url.length >= 2 && url[0].path === 'auth' && url[1].path === 'callback') {
        return null;
      }
      if (url.length >= 1 && url[0].path === 'service-unavailable') {
        return null;
      }
      // Match everything else
      return { consumed: url };
    },
    redirectTo: '/notfound',
  },
];
